/**
 * Episodes Page - View Toggle & LocalStorage Management
 */

document.addEventListener('DOMContentLoaded', function () {
  // Désactiver AOS sur mobile pour meilleures performances
  if (typeof AOS !== 'undefined' && window.innerWidth <= 768) {
    AOS.init({
      disable: true
    });
  }

  const gridViewBtn = document.getElementById('grid-view-btn');
  const listViewBtn = document.getElementById('list-view-btn');
  const episodesContainer = document.getElementById('episodes-container');

  // Récupérer la vue sauvegardée ou utiliser 'grid' par défaut
  const savedView = localStorage.getItem('episodesView') || 'grid';

  // Fonction de debounce pour éviter les clics rapides
  let debounceTimer;
  function debounce(func, delay) {
    return function(...args) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => func.apply(this, args), delay);
    };
  }

  // Fonction pour appliquer la vue
  function setView(view) {
    if (view === 'list') {
      episodesContainer.classList.remove('grid-view');
      episodesContainer.classList.add('list-view');
      gridViewBtn.classList.remove('active');
      listViewBtn.classList.add('active');
    } else {
      episodesContainer.classList.remove('list-view');
      episodesContainer.classList.add('grid-view');
      listViewBtn.classList.remove('active');
      gridViewBtn.classList.add('active');
    }
    localStorage.setItem('episodesView', view);
  }

  // Version debouncée de setView
  const debouncedSetView = debounce(setView, 150);

  // Appliquer la vue sauvegardée au chargement (immédiat, pas de debounce)
  setView(savedView);

  // Événements de clic avec debounce
  gridViewBtn.addEventListener('click', () => debouncedSetView('grid'));
  listViewBtn.addEventListener('click', () => debouncedSetView('list'));
});
